<template>
  <v-list class="pt-20 text-left mh100">
    <h2 class="ml-3">Basic Information</h2>
    <v-divider></v-divider>
    <br />
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm4>
          <h5>Name :</h5>
        </v-flex>
        <v-flex sm8>
          <v-list-tile-content>
            {{ userData.name }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm4>
          <h5>Phone :</h5>
        </v-flex>
        <v-flex sm8>
          <v-list-tile-content>
            <Phone :phone="userData.phone" />
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm4>
          <h5>Email :</h5>
        </v-flex>
        <v-flex sm8>
          <v-list-tile-content>
            {{ userData.email || "-" }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm4>
          <h5>Address :</h5>
        </v-flex>
        <v-flex sm8>
          <v-list-tile-content>
            {{ userData.basic_info.present_address || "-" }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm4>
          <h5>Division :</h5>
        </v-flex>
        <v-flex sm8>
          <v-list-tile-content>
            {{ userData.division_name || "-" }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm4>
          <h5>District :</h5>
        </v-flex>
        <v-flex sm8>
          <v-list-tile-content>
            {{ userData.district_name || "-" }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm4>
          <h5>Gender :</h5>
        </v-flex>
        <v-flex sm8>
          <v-list-tile-content>
            {{ userData.gender || "-" }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm4>
          <h5>Date of Birth :</h5>
        </v-flex>
        <v-flex sm8>
          <v-list-tile-content>
            {{ userData.basic_info.dob || "-" }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm4>
          <h5>Marital Status :</h5>
        </v-flex>
        <v-flex sm8>
          <v-list-tile-content>
            {{ userData.marital_status || "-" }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm4>
          <h5>Govt ID / National ID :</h5>
        </v-flex>
        <v-flex sm8>
          <v-list-tile-content>
            {{ userData.basic_info.gov_id_no || "-" }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm4>
          <h5>NID Verification Status :</h5>
        </v-flex>
        <v-flex sm8>
          <v-list-tile-content>
            <span
              v-if="userData.basic_info.is_nid_verified == 0"
              style="color: orange"
            >
              Not Verified
            </span>
            <span
              v-else-if="userData.basic_info.is_nid_verified == 1"
              style="color: green"
            >
              Verified
            </span>
            <span
              v-else-if="userData.basic_info.is_nid_verified == 2"
              style="color: red"
            >
              Rejected
            </span>
            <span v-else>-</span>
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm4>
          <h5>Gini Score :</h5>
        </v-flex>
        <v-flex sm8>
          <v-list-tile-content>
            {{
              userData.basic_info.gini_score ||
              userData.basic_info.gini_score === 0
                ? userData.basic_info.gini_score
                : "-"
            }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
  </v-list>
</template>
<script>
  import Phone from "@/components/Phone";
  export default {
    props: ["userData"],
    components: {
      Phone,
    },
  };
</script>
